module.exports = __webpack_public_path__ + "static/media/wheelsop.f547ef30.jpg";